import { Controller } from '@hotwired/stimulus'
import { clickedInteractiveTarget } from '../helpers/interactive_click'

// Connects to data-controller="visit"
export default class extends Controller {
  static values = {
    href: String,
    turboFrame: String
  }

  visit (event) {
    if (clickedInteractiveTarget(event)) {
      event.stopPropagation()
      return
    }

    window.Turbo.visit(this.hrefValue, { frame: this.turboFrameValue })
  }
}
